export const GET_COUNTRIES = gql`
    query GetCountries {
        countries {
            alpha2Code
            name
            flags {
                svg
            }
            callingCodes {
                code
            }
        }
    }
`;
